/* eslint-disable react-hooks/exhaustive-deps */
// Still needs to review explanation part
// Revamp color and scaling

import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import PrimaryButtonQuestion from "../../components/button/primary-button/PrimaryButtonQuestion";
import SecondaryButtonQuestion from "../../components/button/secondary-button/SecondaryButtonQuestion";
import TertiaryButtonQuestion from "../../components/button/tertiary-button/TertiaryButtonQuestion";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ImageFromUrl from "../../components/parseImage/ImageFromUrl";
import ConstantStrings from "../../constants/ConstantStrings";
import { checkImage } from "../../constants/checkImage";
import { loadWidthImage } from "../../constants/loadWidthImage";
import {
  setQuestionState,
  setQuestionVisible,
} from "../../reducers/questionsSlice";
import { cachesQuestion, getCachesQuestion } from "../helper/cacheQuestion";
import { sumWithButton } from "../helper/calculateWidthButton";
import jsonParser from "../helper/jsonParser";
import { getConstantStringByLanguage } from "../helper/getConstantStringByLanguage";
import AudioIcon, { handleClickAudio, useAutoPlayAudio } from "../content/Assets/AudioIcon";

function MultipleChoice({
  data,
  sections,
  question,
  explanation,
  backgroundImage,
  section,
  slide,
  submitLesson,
  nextSection,
  setScrollTop,
  buttonSkipRef,
  playingAudioRef,
}) {
  const cache = getCachesQuestion(section, slide);
  const dispatch = useDispatch();
  // const { checkingState, explanationState, selected, setSelected } = useContext(McqContext);
  var questionTexts =
    question.texts !== null &&
      question.texts !== undefined &&
      question.texts?.length > 0
      ? question.texts.map((text, index) => jsonParser(text, index))
      : question.texts;
  var questionChoices = question.choices;
  var questionSolutions = question.solutions;

  // const questionAudioLink = question?.audioLink;
  // const questionAudioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + questionAudioLink));
  // const [isQuestionAudioPlaying, setIsQuestionAudioPlaying] = useState(false);
  
  // useAutoPlayAudio({
  //   content: question,
  //   audioRef: questionAudioRef,
  //   playingAudioRef,
  //   setIsAudioPlaying: setIsQuestionAudioPlaying,
  //   slideId: data._id,
  //   type: 1
  // });

  const explanationAudioLink = explanation?.audioLink;
  const explanationAudioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + explanationAudioLink));
  const [isExplanationAudioPlaying, setIsExplanationAudioPlaying] = useState(false);

  //check if explanation is null
  if (explanation !== null && explanation) {
    if (
      explanation.texts !== null &&
      explanation.texts !== undefined &&
      explanation.texts?.length > 0 &&
      explanation.texts.some((item) => item?.length > 0)
    ) {
      var explanationTexts = explanation.texts.map((text, index) =>
        jsonParser(text, index)
      );
    }
    if (
      explanation.images !== null &&
      explanation.images !== undefined &&
      explanation.images?.length > 0 &&
      explanation.images.some((item) => item?.length > 0)
    ) {
      var explanationImages = explanation.images;
    }
  }

  //create a state variable to store the selected answer
  var [selected, setSelected] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.selected;
    } else {
      return -1;
    }
  });
  //create a state variable to store the checking state
  var [checkingState, setCheckingState] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.checkingState;
    } else {
      return false;
    }
  });
  //create a state variable to store the explanation state
  var [explanationState, setExplanationState] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.explanationState;
    } else {
      return false;
    }
  });

  useAutoPlayAudio({
    content: explanation,
    audioRef: explanationAudioRef,
    playingAudioRef,
    setIsAudioPlaying: setIsExplanationAudioPlaying,
    slideId: data._id,
    explanationState,
    type: 2
  });

  //get max length of a choice
  var maxLength = 0;
  for (var i = 0; i < questionChoices.length; i++) {
    if (questionChoices[i].length > maxLength) {
      maxLength = questionChoices[i].length;
    }
  }
  const [imgWidth, setImgWidth] = useState(() => {
    if (cache?.imgWidth) {
      return cache.imgWidth;
    } else {
      return 0;
    }
  });
  const [widthButton] = useState(
    checkImage(questionChoices[0]) ? 0 : maxLength >= 11 ? 20 : 10
  );
  const [maxWidth, setMaxWidth] = useState(() => {
    if (cache?.maxWidth) {
      return cache.maxWidth;
    } else {
      return 60;
    }
  });
  const [isLoading, setIsLoading] = useState(
    imgWidth === 0 && checkImage(questionChoices[0]) ? true : false
  );

  var backgroundStyle = {
    borderRadius: "0 0 1rem 1rem",
    opacity: 1,
  };
  if (
    backgroundImage !== null &&
    backgroundImage &&
    checkImage(backgroundImage)
  ) {
    backgroundStyle = {
      ...backgroundStyle,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
    };
  }
  let buttonStyle = {};
  if (maxLength <= 10 && !checkImage(questionChoices[0])) {
    buttonStyle = {
      width: "10rem",
      padding: "0.75rem 1rem",
      height: "3rem",
      opacity: 1,
      fontWeight: "bold",
      fontSize: "1.125rem",
    };
  } else {
    if (checkImage(questionChoices[0])) {
      buttonStyle = {
        maxWidth: "20rem",
        width: `${imgWidth !== 0 ? `${imgWidth + 0.125 + 2}rem` : "auto"}`,
        height: "auto",
        padding: "1rem",
        whiteSpace: "pre-wrap",
        outline: "0.0625rem solid",
        opacity: 1,
        borderRadius: "1.5rem",
        fontWeight: "bold",
        fontSize: "1.125rem",
      };
    } else {
      buttonStyle = {
        width: "20rem",
        height: "auto",
        padding: "0.75rem 1.25rem",
        whiteSpace: "pre-wrap",
        outline: "0.0625rem solid",
        opacity: 1,
        fontWeight: "bold",
        fontSize: "1.125rem",
      };
    }
  }

  var selectedStyle = {
    ...buttonStyle,
    outline: "0.125rem solid",
  };

  var iconStyle = {
    zIndex: 100,
    position: "absolute",
    top: "0.7rem",
    width: "1.5rem",
    height: "1.5rem",
    left: "-0.7rem",
  };

  //McqButton component
  const divRef = useRef(null);
  const McqButton = ({ index, children }) => {
    const buttonRef = useRef(null);
    var imageUrl = ConstantStrings.IMAGE_URL + encodeURIComponent(children);
    imageUrl = imageUrl.replace(/\(/g, '%28').replace(/\)/g, '%29')
    if (index === 0 && checkImage(children) && imgWidth === 0) {
      loadWidthImage(imageUrl, (err, img) => {
        setImgWidth(
          (img.width / ConstantStrings.BASE_REM) *
          ConstantStrings.MULTIPLIERIMAGE
        );
      });
    }
    return (
      //if index = selected, set the style to selectedStyle
      //if index = selected and checkingState = true, set the style to correctStyle if the answer is correct, set the style to incorrectStyle if the answer is incorrect
      <div className="is-relative">
        {index === selected && checkingState ? (
          <>
            {questionSolutions[selected] === true ? (
              <img
                src="/images/common/greenV.svg"
                style={iconStyle}
                alt="loading"
              />
            ) : (
              <img
                src="/images/common/redX.svg"
                style={iconStyle}
                alt="loading"
              />
            )}
          </>
        ) : (
          <>
            <div
              style={{
                ...iconStyle,
                width: "0.75rem",
                height: "0.75rem",
              }}
              className="icon"
            ></div>
          </>
        )}
        <button
          ref={buttonRef}
          className={`${index === selected
            ? checkingState
              ? questionSolutions[selected] === true
                ? "has-background-kurio-green-light-3 is-kurio-green-main-accent has-text-kurio-green-main-accent"
                : "has-background-kurio-red-light-3 is-kurio-red-main-accent has-text-kurio-red-main-accent"
              : "has-background-kurio-purple-light-3 is-kurio-purple-main-accent has-text-kurio-purple-main-accent"
            : checkingState
              ? " is-kurio-gray-main-accent has-text-kurio-gray-main-accent"
              : "has-text-kurio-main-color-black is-kurio-main-color-black"
            } button is-shadowless has-text-weight-bold is-outlined has-background-kurio-main-color-white`}
          style={
            index === selected && !checkingState ? selectedStyle : buttonStyle
          }
          onClick={() => handleSelect(index)}
          disabled={checkingState}
        >
          {!children.slice(0, 2).includes("@@") && checkImage(children) ? (
            <>
              <img src={imageUrl} alt="loading" />
            </>
          ) : (
            jsonParser(children)
          )}
        </button>
      </div>
    );
  };
  //mapping each choice to a component
  const MapChoices = questionChoices.map((choice, index) => {
    return (
      //id = "auto-height" if the choice is longer than 32 characters
      <div
        className="column is-narrow"
        style={{ padding: "0.5rem 0.75rem" }}
        key={index}
      >
        <McqButton index={index}>{choice}</McqButton>
      </div>
    );
  });

  //create a function to handle the selection of an answer
  //when an answer is selected, set the selected state variable to the index of the answer
  const handleSelect = (index) => {
    if (selected === index) {
      setSelected(-1);
    } else {
      setSelected(index);
    }
  };

  //create a function to handle the checking of the answer
  //when the answer is checked, set the checking state variable to true
  //if the selected answer is correct, alert "Correct!", change the background color of the selected answer to green
  //if the selected answer is incorrect, alert "Incorrect!", change the background color of the selected answer to red
  const handleCheck = () => {
    if (selected !== -1) {
      if (questionSolutions[selected] === true) {
        // alert("Correct!");
      } else {
        // alert("Incorrect!");
      }
      setCheckingState(true);
    } else {
      // alert("Please select an answer!");
    }
  };

  //create a function to handle the reset of the question
  //when the question is reset, set the selected state variable to -1
  //set the checking state variable to false
  const handleReset = () => {
    setSelected(-1);
    setCheckingState(false);
  };

  //create a function to handle the showing of the explanation
  const handleShowExplanation = () => {
    setExplanationState(true);
  };

  const showNextSlide = () => {
    dispatch(
      setQuestionState({
        section: section,
        index: slide,
        state: {
          selected: selected,
          checkingState: checkingState,
          explanationState: explanationState,
        },
      })
    );
    submitLesson(section, slide);
    if (sections[section].slides[slide].isLast) {
      nextSection();
    } else {
      dispatch(setQuestionVisible({ section: section, index: slide + 1 }));
    }

    setScrollTop(false)
  };

  const McqImageWrap = () => {
    return (
      <>
        {questionChoices.length === 4 &&
          sumWithButton("IMAGE", imgWidth, 4) >= maxWidth ? (
          <div>
            <div className="columns is-centered p-0 m-0">
              {MapChoices[0]}
              {MapChoices[1]}
            </div>
            <div className="columns is-centered p-0 m-0">
              {MapChoices[2]}
              {MapChoices[3]}
            </div>
          </div>
        ) : questionChoices.length === 5 ? (
          <>
            {sumWithButton("IMAGE", imgWidth, 5) >= maxWidth ? (
              <div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[0]}
                  {MapChoices[1]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[2]}
                  {MapChoices[3]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[4]}
                </div>
              </div>
            ) : (
              <div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[0]}
                  {MapChoices[1]}
                  {MapChoices[2]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[3]}
                  {MapChoices[4]}
                </div>
              </div>
            )}
          </>
        ) : questionChoices.length === 6 ? (
          <>
            {sumWithButton("IMAGE", imgWidth, 6) >= maxWidth ? (
              <div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[0]}
                  {MapChoices[1]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[2]}
                  {MapChoices[3]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[4]}
                  {MapChoices[5]}
                </div>
              </div>
            ) : (
              <div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[0]}
                  {MapChoices[1]}
                  {MapChoices[2]}
                </div>
                <div className="columns is-centered p-0 m-0">
                  {MapChoices[3]}
                  {MapChoices[4]}
                  {MapChoices[5]}
                </div>
              </div>
            )}
          </>
        ) : questionChoices.length === 3 ? (
          <>
            {sumWithButton("IMAGE", imgWidth, 3) > maxWidth ? (
              <div>
                <div className="columns is-centered p-0 m-0 ">
                  {MapChoices[0]}
                  {MapChoices[1]}
                </div>
                <div className="columns is-centered p-0 m-0 ">
                  {MapChoices[2]}
                </div>
              </div>
            ) : (
              <div>
                <div className="columns is-centered p-0 m-0 ">
                  {MapChoices[0]}
                  {MapChoices[1]}
                  {MapChoices[2]}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="columns is-multiline is-centered p-0 m-0">
            {MapChoices}
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (imgWidth !== 0) {
      cachesQuestion(section, slide, imgWidth, maxWidth);
      setIsLoading(false);
    }
    if (divRef.current?.clientWidth / ConstantStrings.BASE_REM !== maxWidth) {
      setMaxWidth(divRef.current.clientWidth / ConstantStrings.BASE_REM);
    }
    const setWidth = () => {
      setMaxWidth(divRef.current.clientWidth / ConstantStrings.BASE_REM);
    };
    window.addEventListener("resize", setWidth);
    return () => window.removeEventListener("resize", setWidth);
  }, [imgWidth]);
  //map each choice to a component

  return (
    <div ref={divRef}>
      <BackgroundImageFromUrl
        className={`${!checkImage(backgroundImage)
          ? "has-background-kurio-main-color-light-gray"
          : ""
          }`}
        style={backgroundStyle}
        objectId={backgroundImage}
      >
        {isLoading && <div className="has-text-centered">Loading</div>}
        {!explanationState && (
          <div
            className={`${isLoading ? "is-hidden" : ""
              } question-container is-flex is-flex-direction-column has-text-kurio-main-color-black`}
            style={{
              padding: "1.5rem 2rem",
              gap: "1rem",
            }}
          >
            {/* {jsonParser("$$\\begin{aligned} 12 \\times (20 - 15) &= 12 \\times 5 \\\\ &=  \\color{red}{60}\\end{aligned}$$  \\n @@<p style='color:red'>test ok</p>@@ ")} */}
            {
              //render questionTexts if its array has length greater than 0
              questionTexts !== null &&
              questionTexts !== undefined &&
              questionTexts?.length > 0 && (
                <div
                  className=" has-text-centered m-auto"
                  style={{ maxWidth: "40rem" }}
                >
                  {questionTexts}
                </div>
              )
            }
            {checkImage(questionChoices[0]) ? (
              <>
                <McqImageWrap />
              </>
            ) : (
              <>
                {questionChoices.length === 4 &&
                  sumWithButton("TEXT", widthButton, 4) > maxWidth ? (
                  <div>
                    <div className="columns is-centered p-0 m-0">
                      {MapChoices[0]}
                      {MapChoices[1]}
                    </div>
                    <div className="columns is-centered p-0 m-0">
                      {MapChoices[2]}
                      {MapChoices[3]}
                    </div>
                  </div>
                ) : // if questionChoices has length 5, render the choices in a 3x2 grid
                  questionChoices.length === 5 ? (
                    <>
                      {sumWithButton("TEXT", widthButton, 5) > maxWidth ? (
                        <div>
                          <div className="columns is-centered p-0 m-0">
                            {MapChoices[0]}
                            {MapChoices[1]}
                          </div>
                          <div className="columns is-centered p-0 m-0">
                            {MapChoices[2]}
                            {MapChoices[3]}
                          </div>
                          <div className="columns is-centered p-0 m-0">
                            {MapChoices[4]}
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="columns is-centered p-0 m-0">
                            {MapChoices[0]}
                            {MapChoices[1]}
                            {MapChoices[2]}
                          </div>
                          <div className="columns is-centered p-0 m-0">
                            {MapChoices[3]}
                            {MapChoices[4]}
                          </div>
                        </div>
                      )}
                    </>
                  ) : // if questionChoices has length 6, render the choices in a 3x3 grid
                    questionChoices.length === 6 ? (
                      <>
                        {sumWithButton("TEXT", widthButton, 6) > maxWidth ? (
                          <div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[0]}
                              {MapChoices[1]}
                            </div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[2]}
                              {MapChoices[3]}
                            </div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[4]}
                              {MapChoices[5]}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[0]}
                              {MapChoices[1]}
                              {MapChoices[2]}
                            </div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[3]}
                              {MapChoices[4]}
                              {MapChoices[5]}
                            </div>
                          </div>
                        )}
                      </>
                    ) : questionChoices.length === 3 ? (
                      <>
                        {sumWithButton("TEXT", widthButton, 3) > maxWidth ? (
                          <div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[0]}
                              {MapChoices[1]}
                            </div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[2]}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="columns is-centered p-0 m-0">
                              {MapChoices[0]}
                              {MapChoices[1]}
                              {MapChoices[2]}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="columns is-multiline is-centered p-0 m-0">
                        {MapChoices}
                      </div>
                    )}
              </>
            )}
          </div>
        )}

        {/* only appears when explanationState is true */}
        {explanationState && (
          <div
            className="explanation-container has-text-kurio-main-color-black is-flex is-flex-direction-column is-align-items-center"
            style={{
              gap: "1.5rem",
              fontSize: "1.25rem",
              padding: " 2rem 2rem 1.5rem",
            }}
          >
            {explanationAudioLink && playingAudioRef && <AudioIcon isPlaying={isExplanationAudioPlaying} onClick={() => handleClickAudio(explanationAudioRef, setIsExplanationAudioPlaying)} />}
            {((explanationTexts !== null &&
              explanationTexts !== undefined &&
              explanationTexts?.length > 0) ||
              (explanationImages !== null &&
                explanationImages !== undefined &&
                explanationImages?.length > 0)) &&
              explanation.texts?.length >= explanation.images?.length && (
                <>
                  {explanation.texts.map((item, index) => (
                    <div
                      key={index}
                      className="is-flex is-flex-direction-column is-align-items-center"
                      style={{ gap: "1.5rem" }}
                    >
                      {explanationTexts !== null &&
                        explanationTexts !== undefined &&
                        item?.length > 0 && (
                          <div key={item}>{explanationTexts[index]}</div>
                        )}
                      {/* only appears when explanationImages has length greater than 0 */}
                      {explanationImages !== null &&
                        explanationImages !== undefined &&
                        explanationImages[index]?.length > 0 && (
                          <ImageFromUrl objectId={explanationImages[index]} />
                        )}
                    </div>
                  ))}
                </>
              )}
            {((explanationTexts !== null &&
              explanationTexts !== undefined &&
              explanationTexts?.length > 0) ||
              (explanationImages !== null &&
                explanationImages !== undefined &&
                explanationImages?.length > 0)) &&
              explanation.texts?.length < explanation.images?.length && (
                <>
                  {explanationImages.map((item, index) => (
                    <div
                      key={item}
                      className="is-flex is-flex-direction-column is-align-items-center"
                      style={{ gap: "1.5rem" }}
                    >
                      {explanationTexts !== null &&
                        explanationTexts !== undefined &&
                        explanation.texts[index]?.length > 0 && (
                          <div key={index}>{explanationTexts[index]}</div>
                        )}
                      {/* only appears when explanationImages has length greater than 0 */}
                      {explanationImages !== null &&
                        explanationImages !== undefined &&
                        item?.length > 0 && (
                          <ImageFromUrl objectId={explanationImages[index]} />
                        )}
                    </div>
                  ))}
                </>
              )}
          </div>
        )}
        <div
          className={` is-flex is-flex-direction-row ${!(slide + 1 > sections[section].slides.length - 1
            ? sections[section].isFinished
            : sections[section].slides[slide + 1].visible)
            ? checkingState &&
              questionSolutions[selected] === true &&
              explanation?.texts?.every((item) => item?.length <= 0) &&
              explanation?.images?.every((item) => item?.length <= 0)
              ? "is-align-items-center is-justify-content-center"
              : "is-align-items-flex-end is-justify-content-space-between"
            : "is-align-items-center is-justify-content-center"
            }`}
          style={{
            padding: "0 2rem 2rem",
            gap: "1rem",
          }}
        >
          {/* only appears when checkingState is false */}
          {!checkingState && (
            <PrimaryButtonQuestion
              disabled={selected === -1}
              onClick={handleCheck}
            >
              {getConstantStringByLanguage(ConstantStrings.SUBMIT)}
            </PrimaryButtonQuestion>
          )}
          {/* only appears when checkingState is true and the selected answer is incorrect */}
          {checkingState && questionSolutions[selected] === false && (
            <PrimaryButtonQuestion onClick={handleReset}>
              {getConstantStringByLanguage(ConstantStrings.TRY_AGAIN)}
            </PrimaryButtonQuestion>
          )}
          {/* Next and "Xem giai thich" button appears when checkingState is true and selected answer is correct */}
          <div
            className="is-flex is-flex-direction-row is-align-items-flex-start"
            style={{ gap: "1rem" }}
          >
            {checkingState &&
              questionSolutions[selected] === true &&
              explanationState === false && (
                <>
                  {explanation !== null &&
                    explanation !== undefined &&
                    ((explanationImages !== null &&
                      explanationImages !== undefined &&
                      explanationImages.length > 0) ||
                      (explanationTexts !== null &&
                        explanationTexts !== undefined &&
                        explanationTexts.length > 0)) && (
                      <SecondaryButtonQuestion
                        defaultColor={"is-kurio-purple-light-2"}
                        onClick={handleShowExplanation}
                      >
                        {getConstantStringByLanguage(ConstantStrings.SHOW_EXPLANATION)}
                      </SecondaryButtonQuestion>
                    )}
                </>
              )}
            {/* "Xem cau hoi" button appears when explanationState is true */}
            {explanationState && (
              <SecondaryButtonQuestion
                defaultColor={"is-kurio-purple-light-2"}
                onClick={() => {
                  setExplanationState(false);
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.SHOW_QUESTION)}
              </SecondaryButtonQuestion>
            )}
          </div>
          {checkingState && questionSolutions[selected] === true && (
            <div
              className={`${(
                slide + 1 > sections[section].slides.length - 1
                  ? sections[section].isFinished
                  : sections[section].slides[slide + 1].visible
              )
                ? "is-hidden"
                : ""
                } `}
            >
              <PrimaryButtonQuestion onClick={showNextSlide}>
                {getConstantStringByLanguage(ConstantStrings.NEXT)}
              </PrimaryButtonQuestion>
            </div>
          )}

          {((questionSolutions[selected] !== true && checkingState) ||
            !checkingState) && (
              <div
                className={`${(
                  slide + 1 > sections[section].slides.length - 1
                    ? sections[section].isFinished
                    : sections[section].slides[slide + 1].visible
                )
                  ? "is-hidden"
                  : ""
                  } `}
              >
                <TertiaryButtonQuestion
                  onClick={showNextSlide}
                  suffix={"admin/frontend-images/button/button-skip-icon"}
                >
                  {getConstantStringByLanguage(ConstantStrings.SKIP)}
                </TertiaryButtonQuestion>
              </div>
            )}
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    sections: state.questions.sections,
  };
}

export default connect(mapStateToProps)(MultipleChoice);
